import { req } from '../../@api/request';

export default class PromotionService {
  static promotion = async (promotionCode: string) => {
    const result = await req.post(`/promotion`, { promotionCode });
    return result.data;
  };

  static code = async () => {
    const result = await req.get(`/promotion`);
    return result.data;
  };
}
